import { graphql } from 'gatsby';
import ProductionPage from "../../../../src/pages/production";
import * as React from 'react';
export default {
  graphql,
  ProductionPage,
  React
};